var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgServiceIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0899 7.40692C11.6994 7.79744 11.6994 8.43061 12.0899 8.82113L15.7039 12.4352C16.0944 12.8257 16.7276 12.8257 17.1181 12.4352L20.7322 8.82113C21.1227 8.43061 21.1227 7.79744 20.7322 7.40692L17.1181 3.79289C16.7276 3.40237 16.0944 3.40237 15.7039 3.79289L12.0899 7.40692ZM4 4.49944C3.44772 4.49944 3 4.94715 3 5.49944V10.5683C3 11.1206 3.44772 11.5683 4 11.5683H9.06884C9.62112 11.5683 10.0688 11.1206 10.0688 10.5683V5.49944C10.0688 4.94715 9.62112 4.49944 9.06884 4.49944H4ZM4 14.3958C3.44772 14.3958 3 14.8435 3 15.3958V20.4646C3 21.0169 3.44772 21.4646 4 21.4646H9.06884C9.62112 21.4646 10.0688 21.0169 10.0688 20.4646V15.3958C10.0688 14.8435 9.62112 14.3958 9.06884 14.3958H4ZM12.8968 15.3958C12.8968 14.8435 13.3445 14.3958 13.8968 14.3958H18.9656C19.5179 14.3958 19.9656 14.8435 19.9656 15.3958V20.4646C19.9656 21.0169 19.5179 21.4646 18.9656 21.4646H13.8968C13.3445 21.4646 12.8968 21.0169 12.8968 20.4646V15.3958Z",
    fill: "#0A186E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgServiceIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/service-icon.2dc3512bba5e3a725f4b64a9c8534199.svg";